import './assets/main.css'

import {createApp} from 'vue'
import {createPinia} from 'pinia'

import App from './App.vue'
import router from './router'

import '@vuepic/vue-datepicker/dist/main.css'
import '@lottiefiles/lottie-player'
import Vue3Toastify from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import 'primeicons/primeicons.css'
import {Chart, registerables} from 'chart.js'
import PrimeVue from 'primevue/config'

Chart.register(...registerables)

const app = createApp(App)
const pinia = createPinia()

app.use(Vue3Toastify, {
  theme: 'light',
  type: 'warning',
  limit: 3,
  position: 'top-center',
  autoClose: 3000,
  dangerouslyHTMLString: true,
  expandCustomProps: true,
})
app.use(PrimeVue)
app.use(pinia)
app.use(router)

import { setupApiInterceptors } from '@/services/default'
import { useAuthStore } from '@/stores'
const authStore = useAuthStore()
setupApiInterceptors(authStore)
authStore.initAuth?.()

app.mount('#app')
